import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The old ETL routes, pointed at the merged page.
 *
 * `/file-tracking/:view` is the one that matters most: it is what the file
 * alert emails link to, so the view→tab mapping has to survive. `historical`
 * folded into the Status tab as a range toggle, so it lands there and the tab
 * opens on the calendar.
 */
const FILE_TRACKING_VIEWS = {
  current: 'status',
  historical: 'status',
  documents: 'documents',
  issues: 'issues',
  'unmapped-codes': 'unmapped',
  configurations: 'feeds',
};

export default function EtlRedirect({ to, withHotelId = false, legacyFileTracking = false }) {
  const { view, hotelId } = useParams();
  const { search } = useLocation();

  let target = to;
  let extra = '';

  if (legacyFileTracking) {
    target = FILE_TRACKING_VIEWS[view] || 'status';
    if (view === 'historical') extra = search ? '&range=calendar' : '?range=calendar';
  } else if (withHotelId && hotelId) {
    target = `${to}/${hotelId}`;
  }

  return <Navigate to={`/etl-config/${target}${search}${extra}`} replace />;
}
